import { OnBoardingDocumentUserModel } from "src/app/models/onBoardingDocumentUserModel";
import {
  getOnboardingUserDocs,
  resendOnboardingDocUserForce,
  updateOnboardingUserDocForceNotRequired,
  resendOnboardingDocUserForceSuccess,
  updateOnboardingUserDocForceNotRequiredSuccess,
} from "./../../../../../core/store/onboardingdocs/onboardingdocs.actions";
import { PagingResultsModel } from "./../../../../../models/pagingResultsModel";
import { Component, OnInit, signal, computed } from "@angular/core";
import { Store } from "@ngrx/store";
import { State } from "../../../../../core/store";
import { BaseComponent } from "src/app/core/abstracts/baseComponent";
import { Actions, ofType } from "@ngrx/effects";
import { tap } from "rxjs";
import { AlertService } from "src/app/shared/services/alert.service";
import { Router } from "@angular/router";
import { deepClone } from "src/app/helpers/utils";
import { loadUserTypes } from "src/app/core/store/profile/profile.actions";

@Component({
    selector: "app-list-onboardinguserdocs",
    templateUrl: "./list-onboardinguserdocs.component.html",
    styleUrls: ["./list-onboardinguserdocs.component.scss"],
    standalone: false
})
export class ListOnboardingUserDocsComponent
  extends BaseComponent
  implements OnInit
{
  onboardingUserDocs: PagingResultsModel<OnBoardingDocumentUserModel>;
  canEdit: boolean;
  canView: boolean;
  loadingUserDocs = false;
  filter: any;
  employeeNameFilter: string;
  documentNameFilter: string;
  createDateFilter;
  signedDateFilter;
  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });

  constructor(
    private actions$: Actions,
    private alertService: AlertService,
    private store: Store<State>,
    private router: Router,
  ) {
    super();
  }

  ngOnInit() {
    this.subs.push(
      this.store
        .select((s) => s.accountState.user?.permissionIDs)
        .subscribe((permissionIDs) => {
          this.canEdit =
            permissionIDs && !!permissionIDs.find((p) => p === 3060); // manage
          this.canView =
            permissionIDs &&
            !!permissionIDs.find((p) => p === 3059 || p === 3060); // view
        }),
      this.store
        .select((s) => s.onBoardingDocsState.usersDocs)
        .subscribe((usersDocs) => {
          if (usersDocs) {
            this.onboardingUserDocs = usersDocs;
            this.totalRecords.set(usersDocs.totalRecords);
          }
        }),

      this.store
        .select((s) => s.onBoardingDocsState.loadingUserDocs)
        .subscribe((loadingUserDocs) => {
          this.loadingUserDocs = loadingUserDocs;
        }),

      this.actions$
        .pipe(
          ofType(
            updateOnboardingUserDocForceNotRequiredSuccess,
            resendOnboardingDocUserForceSuccess,
          ),
          tap((action) => {
            this.loadPage(this.filter);
          }),
        )
        .subscribe(),
    );
  }

  changedFilters() {
    this.loadPage(this.filter);
  }

  loadPage(event) {
    this.filter = event;
    this.filter = deepClone(event);
    this.filter.filters.employee = {
      Name: "employee",
      Value: { value: this.employeeNameFilter },
    };
    this.filter.filters.document = {
      Name: "document",
      Value: { value: this.documentNameFilter },
    };

    if (this.createDateFilter) {
      this.filter.filters.createdDateFrom = {
        Name: "createdDateFrom",
        Value: { value: this.createDateFilter[0] },
      };
      this.filter.filters.createdDateTo = {
        Name: "createdDateTo",
        Value: { value: this.createDateFilter[1] },
      };
    } else {
      this.filter.filters.createdDateFrom = {
        Name: "createdDateFrom",
        Value: { value: null },
      };
      this.filter.filters.createdDateTo = {
        Name: "createdDateTo",
        Value: { value: null },
      };
    }

    if (this.signedDateFilter) {
      this.filter.filters.signedDateFrom = {
        Name: "signedDateFrom",
        Value: { value: this.signedDateFilter[0] },
      };
      this.filter.filters.signedDateTo = {
        Name: "signedDateTo",
        Value: { value: this.signedDateFilter[1] },
      };
    } else {
      this.filter.filters.signedDateFrom = {
        Name: "signedDateFrom",
        Value: { value: null },
      };
      this.filter.filters.signedDateTo = {
        Name: "signedDateTo",
        Value: { value: null },
      };
    }

    this.store.dispatch(
      getOnboardingUserDocs({ filter: deepClone(this.filter) }),
    );
  }

  forceNotRequired(doc: OnBoardingDocumentUserModel) {
    this.store.dispatch(
      updateOnboardingUserDocForceNotRequired({
        model: { onBoardingDocUserID: doc.id, forceNotRequired: true },
      }),
    );
  }

  unForceNotRequired(doc: OnBoardingDocumentUserModel) {
    this.store.dispatch(
      updateOnboardingUserDocForceNotRequired({
        model: { onBoardingDocUserID: doc.id, forceNotRequired: false },
      }),
    );
  }

  forceReassign(doc: OnBoardingDocumentUserModel) {
    this.store.dispatch(
      resendOnboardingDocUserForce({
        model: { onBoardingDocUserID: doc.id, force: true },
      }),
    );
  }
}
